{
  "query": {
    "inlineRetrieveUserPermissions": "/multiregion",
    "v2CheckRecipientLinkAccountEligibility": "/multiregion",
    "v2CheckRecipientLinkSignupEligibility": "/multiregion",
    "v2CheckUserInviteEligibility": "/onlinelz",
    "v2ComputeMfa": "/onlinelz",
    "v2CreateFunctionImplementationVersion": "/multiregion",
    "v2DashboardDeserializeWorkflowDefinitionDeepLink": "/multiregion",
    "v2DashboardFindObjectDefinitionByApiNamePlural": "/multiregion",
    "v2DashboardFindObjectDefinitionByName": "/multiregion",
    "v2DashboardListActions": "/multiregion",
    "v2DashboardListObjectDefinitions": "/multiregion",
    "v2DashboardListResources": "/multiregion",
    "v2DashboardListStripeApiVersions": "/multiregion",
    "v2DashboardListTriggers": "/multiregion",
    "v2DashboardListWorkflowRunSteps": "/multiregion",
    "v2DashboardListWorkflowRuns": "/multiregion",
    "v2DashboardListWorkflows": "/multiregion",
    "v2DashboardParseToProperties": "/multiregion",
    "v2DashboardRetrieveObjectDefinition": "/multiregion",
    "v2DashboardRetrieveObjectRecord": "/multiregion",
    "v2DashboardRetrieveWorkflow": "/multiregion",
    "v2DashboardRetrieveWorkflowRun": "/multiregion",
    "v2DashboardRetrieveWorkflowVersion": "/multiregion",
    "v2DashboardSerializeWorkflowDefinitionDeepLink": "/multiregion",
    "v2DownloadExport": "/multiregion",
    "v2EstimateFees": "/multiregion",
    "v2EvaluateExperimentVariants": "/multiregion",
    "v2EvaluateExperimentVariantsLoadTest": "/multiregion",
    "v2EvaluateFeatureFlagsLoadTest": "/multiregion",
    "v2EvaluateFeatureFlagsV2": "/multiregion",
    "v2GetApiPolicyBannerContext": "/multiregion",
    "v2GetAssignableRoles": "/onlinelz",
    "v2GetBillingTransaction": "/multiregion",
    "v2GetCardSpendInsights": "/multiregion",
    "v2GetCompartmentByV1AccountGraphQL": "/multiregion",
    "v2GetCompartmentLimitsGraphQL": "/multiregion",
    "v2GetCoreFieldsForWorkspace": "/multiregion",
    "v2GetCryptoInvestmentInfo": "/multiregion",
    "v2GetFeatureConfigurationIntent": "/multiregion",
    "v2GetFeatureConfigurationIntentByFeatureMutationId": "/multiregion",
    "v2GetFeatureConfigurationIntentLogs": "/multiregion",
    "v2GetFeatureConfigurationIntentQuestionnaire": "/multiregion",
    "v2GetFeatures": "/multiregion",
    "v2GetFeeEntries": "/multiregion",
    "v2GetFinancialAccountBalance": "/multiregion",
    "v2GetFinancialAccountRewardsInformation": "/multiregion",
    "v2GetFunctionImplementation": "/multiregion",
    "v2GetFunctionImplementationVersionForImplementation": "/multiregion",
    "v2GetFunctionality": "/multiregion",
    "v2GetHostedRecipientOnboardingFlags": "/multiregion",
    "v2GetInboundTransferLimits": "/multiregion",
    "v2GetInvite": "/multiregion",
    "v2GetInvitedWorkspacesWithinOrganization": "/multiregion",
    "v2GetInvoicingEligibilitiesAtTime": "/multiregion",
    "v2GetInvoicingEligibilitiesAtTimeV2": "/multiregion",
    "v2GetLlamaForCanaryWithRateLimit": "/multiregion",
    "v2GetNearestLivemodeParentCompartmentAttributes": "/multiregion",
    "v2GetNearestPlaygroundId": "/multiregion",
    "v2GetOnboardingSandboxStatus": "/multiregion",
    "v2GetOrganizationById": "/multiregion",
    "v2GetOzoneAuthorization": "/multiregion",
    "v2GetParentOrganizationAttributes": "/multiregion",
    "v2GetPlaygroundIdForCompartmentId": "/multiregion",
    "v2GetProgram": "/multiregion",
    "v2GetProgramDetails": "/multiregion",
    "v2GetReplicatedLivemodeCompartmentAttributes": "/multiregion",
    "v2GetRequirements": "/multiregion",
    "v2GetRevenueContractByAgreementReference": "/multiregion",
    "v2GetRevenueContractByDeliveryReference": "/multiregion",
    "v2GetRoleAssignments": "/onlinelz",
    "v2GetScriptRun": "/multiregion",
    "v2GetTaxIntegrationConfiguration": "/multiregion",
    "v2GetTeamByCompartment": "/onlinelz",
    "v2GetTestmodeStatusFromContext": "/multiregion",
    "v2GetUserAccessibleAccounts": "/multiregion",
    "v2GetUserAccessibleReparentableSandboxes": "/multiregion",
    "v2GetUserAccessibleSandboxes": "/multiregion",
    "v2GetUserAccessibleWorkspacesWithinOrganization": "/multiregion",
    "v2GetUserState": "/multiregion",
    "v2GetV1AccountByCompartmentGraphQL": "/multiregion",
    "v2GetWorkspaceBrandingSettings": "/multiregion",
    "v2GetWorkspacesEligibleForOrganization": "/multiregion",
    "v2GetWorkspacesWithinOrganization": "/multiregion",
    "v2InitiateTestSamlLogin": "/onlinelz",
    "v2ListAccountSignals": "/multiregion",
    "v2ListAccountVersions": "/multiregion",
    "v2ListActionableErrors": "/multiregion",
    "v2ListActiveFeatureConfigurationIntents": "/multiregion",
    "v2ListActivityLogs": "/multiregion",
    "v2ListAdjustments": "/multiregion",
    "v2ListAggregateSsoDomains": "/onlinelz",
    "v2ListAlertHistory": "/multiregion",
    "v2ListAlerts": "/multiregion",
    "v2ListAlertsByPredicate": "/multiregion",
    "v2ListAllAccountGroupsByWorkspaceMember": "/multiregion",
    "v2ListAllAccountGroupsOwnedByCompartment": "/multiregion",
    "v2ListAmazonEventBridgeRegions": "/multiregion",
    "v2ListApiKeys": "/multiregion",
    "v2ListApprovalRequests": "/multiregion",
    "v2ListAvailableDestinations": "/multiregion",
    "v2ListAzureEventGridRegions": "/multiregion",
    "v2ListBalanceExchanges": "/multiregion",
    "v2ListBillSettingVersions": "/multiregion",
    "v2ListBillSettings": "/multiregion",
    "v2ListBills": "/multiregion",
    "v2ListCadenceSpendModifierRules": "/multiregion",
    "v2ListCadences": "/multiregion",
    "v2ListCatalogItemTypes": "/multiregion",
    "v2ListCatalogItems": "/multiregion",
    "v2ListCatalogLocations": "/multiregion",
    "v2ListCatalogPriceBooks": "/multiregion",
    "v2ListCatalogProviders": "/multiregion",
    "v2ListCatalogProvidersInternal": "/multiregion",
    "v2ListCatalogServices": "/multiregion",
    "v2ListCatalogServicesInternal": "/multiregion",
    "v2ListCatalogs": "/multiregion",
    "v2ListCharges": "/multiregion",
    "v2ListChargesInternal": "/multiregion",
    "v2ListCheckoutIntegrations": "/multiregion",
    "v2ListCheckoutPlans": "/multiregion",
    "v2ListClaims": "/multiregion",
    "v2ListCollectionSettingVersions": "/multiregion",
    "v2ListCollectionSettings": "/multiregion",
    "v2ListCompartmentKeys": "/multiregion",
    "v2ListConfigurationVersions": "/multiregion",
    "v2ListContractPricingLineQuantityChanges": "/multiregion",
    "v2ListContractPricingSegments": "/multiregion",
    "v2ListContracts": "/multiregion",
    "v2ListCorgi": "/multiregion",
    "v2ListCryptoInvestmentDeposits": "/multiregion",
    "v2ListCryptoInvestmentInfo": "/multiregion",
    "v2ListCryptoInvestmentWithdrawals": "/multiregion",
    "v2ListCurrencyConversions": "/multiregion",
    "v2ListCustomPricingUnits": "/multiregion",
    "v2ListCustomRoles": "/multiregion",
    "v2ListCustomerConsentRequests": "/onlinelz",
    "v2ListDatabaseUsers": "/multiregion",
    "v2ListDatabases": "/multiregion",
    "v2ListDebitDisputes": "/multiregion",
    "v2ListDefaultAccountMappingVersions": "/multiregion",
    "v2ListDeliveriesForEvent": "/multiregion",
    "v2ListDraftSessionDraftMutations": "/multiregion",
    "v2ListDraftSessionDraftObjects": "/multiregion",
    "v2ListEarnedCredits": "/multiregion",
    "v2ListEligibleWorkspacesForAccountGroup": "/multiregion",
    "v2ListEventDeliveriesForDestination": "/multiregion",
    "v2ListEventDestinations": "/multiregion",
    "v2ListEventTypes": "/multiregion",
    "v2ListEvents": "/multiregion",
    "v2ListEventsForDashboard": "/multiregion",
    "v2ListEventsForEventDestination": "/multiregion",
    "v2ListExpenses": "/multiregion",
    "v2ListExports": "/multiregion",
    "v2ListFeatures": "/multiregion",
    "v2ListFeaturesForWorkspace": "/multiregion",
    "v2ListFeaturesInternal": "/multiregion",
    "v2ListFeeBatches": "/multiregion",
    "v2ListFeeEntries": "/multiregion",
    "v2ListFinancialAccountBalances": "/multiregion",
    "v2ListFinancialAccountStatements": "/multiregion",
    "v2ListFinancialAccounts": "/multiregion",
    "v2ListFinancialAddresses": "/multiregion",
    "v2ListFinancialAddressesV2": "/multiregion",
    "v2ListFunctionImplementationVersions": "/multiregion",
    "v2ListFunctionImplementations": "/multiregion",
    "v2ListFunctionalities": "/multiregion",
    "v2ListFunctionalityAuditLogs": "/multiregion",
    "v2ListFundingSessionReceivedCredits": "/multiregion",
    "v2ListGbBankAccounts": "/multiregion",
    "v2ListHealthAlertCategories": "/multiregion",
    "v2ListHealthAlertEmailNotifications": "/multiregion",
    "v2ListHealthAlertGroupEmailNotifications": "/multiregion",
    "v2ListHealthAlertGroups": "/multiregion",
    "v2ListHealthAlertHistoryEntries": "/multiregion",
    "v2ListHealthAlertNotifications": "/multiregion",
    "v2ListHealthAlertWebhookDestinations": "/multiregion",
    "v2ListHealthAlerts": "/multiregion",
    "v2ListHealthInsightLogs": "/multiregion",
    "v2ListHealthInsightNotifications": "/multiregion",
    "v2ListHealthInsights": "/multiregion",
    "v2ListIdMappings": "/multiregion",
    "v2ListInboundTransferMandates": "/multiregion",
    "v2ListInboundTransfers": "/multiregion",
    "v2ListInlineTenantMigrationRecords": "/multiregion",
    "v2ListInquiries": "/multiregion",
    "v2ListIntegHlthAlerts": "/multiregion",
    "v2ListIntentActions": "/multiregion",
    "v2ListIntents": "/multiregion",
    "v2ListJournalEntries": "/multiregion",
    "v2ListKeyRestrictionTemplates": "/multiregion",
    "v2ListLedgerAccounts": "/multiregion",
    "v2ListLicenseFeeVersions": "/multiregion",
    "v2ListLicenseFees": "/multiregion",
    "v2ListLicensedItems": "/multiregion",
    "v2ListLlamas": "/multiregion",
    "v2ListLlamasNotForProdUse": "/multiregion",
    "v2ListLogDestinations": "/multiregion",
    "v2ListLogicalEventsForDashboard": "/multiregion",
    "v2ListManualRules": "/multiregion",
    "v2ListMeteredItems": "/multiregion",
    "v2ListObjectDefinitionGroupVersions": "/multiregion",
    "v2ListObjectDefinitionGroups": "/multiregion",
    "v2ListObjectDefinitionVersions": "/multiregion",
    "v2ListObjectDefinitions": "/multiregion",
    "v2ListObjectRecord": "/multiregion",
    "v2ListOffSessionPayments": "/multiregion",
    "v2ListOffSessionSources": "/multiregion",
    "v2ListOnSessionSources": "/multiregion",
    "v2ListOneTimeItems": "/multiregion",
    "v2ListOrders": "/multiregion",
    "v2ListOrgSupportConversations": "/multiregion",
    "v2ListOrganizationHealthInsights": "/multiregion",
    "v2ListOutboundDestinations": "/multiregion",
    "v2ListOutboundPayments": "/multiregion",
    "v2ListOutboundSetupIntents": "/multiregion",
    "v2ListOutboundTransfers": "/multiregion",
    "v2ListPackagingConfigurations": "/multiregion",
    "v2ListPaymentReservations": "/multiregion",
    "v2ListPaymentSessions": "/multiregion",
    "v2ListPayoutIntents": "/multiregion",
    "v2ListPayoutMethods": "/multiregion",
    "v2ListPersonsDirectAccount": "/multiregion",
    "v2ListPipelines": "/multiregion",
    "v2ListPricingPlanComponents": "/multiregion",
    "v2ListPricingPlanSubscriptions": "/multiregion",
    "v2ListPricingPlanVersions": "/multiregion",
    "v2ListPricingPlans": "/multiregion",
    "v2ListProductCatalogImports": "/multiregion",
    "v2ListProfiles": "/multiregion",
    "v2ListProjectVariables": "/multiregion",
    "v2ListProjectVariablesInternal": "/multiregion",
    "v2ListProjects": "/multiregion",
    "v2ListProjectsInternal": "/multiregion",
    "v2ListProviderConnections": "/multiregion",
    "v2ListProviderConnectionsInternal": "/multiregion",
    "v2ListProviderProjects": "/multiregion",
    "v2ListProviders": "/multiregion",
    "v2ListProvidersInternal": "/multiregion",
    "v2ListPublicKeys": "/multiregion",
    "v2ListRateCardCustomPricingUnitOverageRates": "/multiregion",
    "v2ListRateCardCustomUnitOverageRates": "/multiregion",
    "v2ListRateCardRates": "/multiregion",
    "v2ListRateCardSubscriptions": "/multiregion",
    "v2ListRateCardVersions": "/multiregion",
    "v2ListRateCards": "/multiregion",
    "v2ListReceivedCredits": "/multiregion",
    "v2ListReceivedDebitMandates": "/multiregion",
    "v2ListReceivedDebits": "/multiregion",
    "v2ListRecipientVerifications": "/multiregion",
    "v2ListRecordsByAccountId": "/multiregion",
    "v2ListRecordsByTenantId": "/multiregion",
    "v2ListRecurringCreditGrantVersions": "/multiregion",
    "v2ListRecurringCreditGrants": "/multiregion",
    "v2ListRelatedObjectRecordsInternal": "/multiregion",
    "v2ListRequestLogs": "/multiregion",
    "v2ListResourceCopyRecords": "/multiregion",
    "v2ListResourceSharingEligibilityCheckStatus": "/multiregion",
    "v2ListResources": "/multiregion",
    "v2ListResourcesInternal": "/multiregion",
    "v2ListRevenueTreatmentItemMappingVersions": "/multiregion",
    "v2ListRevenueTreatmentItemMappings": "/multiregion",
    "v2ListRevenueTreatmentVersions": "/multiregion",
    "v2ListRevenueTreatments": "/multiregion",
    "v2ListRewardProgramEnrollments": "/multiregion",
    "v2ListRewardProgramRules": "/multiregion",
    "v2ListRewardPrograms": "/multiregion",
    "v2ListSamlConfiguredSsoDomains": "/onlinelz",
    "v2ListScriptCustomizations": "/multiregion",
    "v2ListServiceActionVersions": "/multiregion",
    "v2ListServicePrincipals": "/onlinelz",
    "v2ListServices": "/multiregion",
    "v2ListSettingsVersions": "/multiregion",
    "v2ListSettlementAllocationIntentSplits": "/multiregion",
    "v2ListSettlementAllocationIntents": "/multiregion",
    "v2ListSpend": "/multiregion",
    "v2ListSsoDomains": "/onlinelz",
    "v2ListStaxRubyModels": "/multiregion",
    "v2ListStaxRubyTenantMigrationRecords": "/multiregion",
    "v2ListStreams": "/multiregion",
    "v2ListTables": "/multiregion",
    "v2ListTenantMigrationRecords": "/multiregion",
    "v2ListTransactionEntries": "/multiregion",
    "v2ListTransactions": "/multiregion",
    "v2ListTrustedWorkloadProviders": "/onlinelz",
    "v2ListUsBankAccounts": "/multiregion",
    "v2ListUserFunctionImplementationsByScriptType": "/multiregion",
    "v2ListUserGroupMembers": "/onlinelz",
    "v2ListUserGroups": "/onlinelz",
    "v2ListUserLevelExperiments": "/multiregion",
    "v2ListUserVisiblePermissions": "/multiregion",
    "v2ListWorkflowRuns": "/multiregion",
    "v2ListWorkflowVersionHistory": "/multiregion",
    "v2ListWorkflowVersions": "/multiregion",
    "v2ListWorkflows": "/multiregion",
    "v2NoOpChargeRead": "/multiregion",
    "v2NoOpConnectedAccountRead": "/multiregion",
    "v2NoOpCustomerRead": "/multiregion",
    "v2NoOpDashboardFullChromeAndTestModeRead": "/multiregion",
    "v2NoOpDisputeRead": "/multiregion",
    "v2NoOpFinancialStatementRead": "/multiregion",
    "v2NoOpInvoiceRead": "/multiregion",
    "v2NoOpRadarDashboardDisputesRead": "/multiregion",
    "v2NoOpReportingRead": "/multiregion",
    "v2NoOpSubscriptionRead": "/multiregion",
    "v2OutboundDestinationBankAccountSpec": "/multiregion",
    "v2RetrieveAccountRequestInternal": "/multiregion",
    "v2RetrieveAccountSignal": "/multiregion",
    "v2RetrieveAccountVersion": "/multiregion",
    "v2RetrieveActivityLog": "/multiregion",
    "v2RetrieveAdjustment": "/multiregion",
    "v2RetrieveAlert": "/multiregion",
    "v2RetrieveAllActionSchemas": "/multiregion",
    "v2RetrieveAllCorgis": "/multiregion",
    "v2RetrieveAllDashboardTransactions": "/multiregion",
    "v2RetrieveAllLlamasByType": "/multiregion",
    "v2RetrieveApiKey": "/multiregion",
    "v2RetrieveApprovalRequest": "/multiregion",
    "v2RetrieveAuthor": "/multiregion",
    "v2RetrieveAuthorizationRequest": "/onlinelz",
    "v2RetrieveBalanceExchange": "/multiregion",
    "v2RetrieveBatchJob": "/multiregion",
    "v2RetrieveBill": "/multiregion",
    "v2RetrieveBillSetting": "/multiregion",
    "v2RetrieveBillSettingVersion": "/multiregion",
    "v2RetrieveBook": "/multiregion",
    "v2RetrieveBookWithTest": "/multiregion",
    "v2RetrieveBulkCopyOperation": "/multiregion",
    "v2RetrieveCadence": "/multiregion",
    "v2RetrieveCadenceSpendModifierRule": "/multiregion",
    "v2RetrieveCalculation": "/multiregion",
    "v2RetrieveCardCreatorConfigForWorkspace": "/multiregion",
    "v2RetrieveCatalog": "/multiregion",
    "v2RetrieveCatalogItem": "/multiregion",
    "v2RetrieveCheckoutForm": "/multiregion",
    "v2RetrieveCheckoutIntegration": "/multiregion",
    "v2RetrieveCheckoutPlan": "/multiregion",
    "v2RetrieveCheckoutSession": "/multiregion",
    "v2RetrieveClaim": "/multiregion",
    "v2RetrieveClaimableSandbox": "/multiregion",
    "v2RetrieveClaimableSandboxStatus": "/multiregion",
    "v2RetrieveCollectionSetting": "/multiregion",
    "v2RetrieveCollectionSettingVersion": "/multiregion",
    "v2RetrieveCompartmentConfiguration": "/multiregion",
    "v2RetrieveCompartmentKey": "/multiregion",
    "v2RetrieveConfigurationVersion": "/multiregion",
    "v2RetrieveConnectionSession": "/multiregion",
    "v2RetrieveContract": "/multiregion",
    "v2RetrieveCorgi": "/multiregion",
    "v2RetrieveCorgiMission": "/multiregion",
    "v2RetrieveCryptoInvestmentDeposit": "/multiregion",
    "v2RetrieveCryptoInvestmentWithdrawal": "/multiregion",
    "v2RetrieveCryptoWallet": "/multiregion",
    "v2RetrieveCurrencyConversion": "/multiregion",
    "v2RetrieveCustomActionSchemaWithFormState": "/multiregion",
    "v2RetrieveCustomPricingUnit": "/multiregion",
    "v2RetrieveCustomRole": "/multiregion",
    "v2RetrieveCustomerConsentRequest": "/onlinelz",
    "v2RetrieveCustomerConsentRequestSummary": "/onlinelz",
    "v2RetrieveDashboardCurrencyConversion": "/multiregion",
    "v2RetrieveDatabase": "/multiregion",
    "v2RetrieveDatabaseUser": "/multiregion",
    "v2RetrieveDebitDispute": "/multiregion",
    "v2RetrieveDefaultAccountMapping": "/multiregion",
    "v2RetrieveDefaultAccountMappingVersion": "/multiregion",
    "v2RetrieveDeviceAuthorization": "/onlinelz",
    "v2RetrieveDirectAccount": "/multiregion",
    "v2RetrieveDoc": "/multiregion",
    "v2RetrieveDraftObject": "/multiregion",
    "v2RetrieveDraftSession": "/multiregion",
    "v2RetrieveEarnedCredit": "/multiregion",
    "v2RetrieveEligibility": "/multiregion",
    "v2RetrieveEligibilityInternal": "/multiregion",
    "v2RetrieveEntity": "/multiregion",
    "v2RetrieveEnvironmentInfo": "/multiregion",
    "v2RetrieveEnvironmentInfoInternal": "/multiregion",
    "v2RetrieveEvent": "/multiregion",
    "v2RetrieveEventDestination": "/multiregion",
    "v2RetrieveEventDestinationWebhookSigningKey": "/multiregion",
    "v2RetrieveEventWithDeliveries": "/multiregion",
    "v2RetrieveExpense": "/multiregion",
    "v2RetrieveExpenseAssociations": "/multiregion",
    "v2RetrieveExpenseAssociationsByFlows": "/multiregion",
    "v2RetrieveExport": "/multiregion",
    "v2RetrieveFeeBatch": "/multiregion",
    "v2RetrieveFeeEntry": "/multiregion",
    "v2RetrieveFinancialAccount": "/multiregion",
    "v2RetrieveFinancialAccountStatement": "/multiregion",
    "v2RetrieveFinancialAccountWalletExport": "/multiregion",
    "v2RetrieveFinancialAddress": "/multiregion",
    "v2RetrieveFinancialAddressV2": "/multiregion",
    "v2RetrieveFineGrainedSand": "/multiregion",
    "v2RetrieveFineGrainedSandWithTest": "/multiregion",
    "v2RetrieveFlowsFilterCounts": "/multiregion",
    "v2RetrieveFundingSession": "/multiregion",
    "v2RetrieveFxQuote": "/multiregion",
    "v2RetrieveFxQuoteForOriginatedMoneyTransfer": "/multiregion",
    "v2RetrieveGbBankAccount": "/multiregion",
    "v2RetrieveHealthAlert": "/multiregion",
    "v2RetrieveHealthAlertCategory": "/multiregion",
    "v2RetrieveHealthAlertCategoryConfig": "/multiregion",
    "v2RetrieveHealthAlertCounts": "/multiregion",
    "v2RetrieveHealthAlertGroup": "/multiregion",
    "v2RetrieveHealthAlertGroupCounts": "/multiregion",
    "v2RetrieveHealthAlertGroupImpact": "/multiregion",
    "v2RetrieveHealthAlertNotification": "/multiregion",
    "v2RetrieveHealthInsight": "/multiregion",
    "v2RetrieveHealthInsightCounts": "/multiregion",
    "v2RetrieveHealthInsightLog": "/multiregion",
    "v2RetrieveHealthInsightNotification": "/multiregion",
    "v2RetrieveIdMapping": "/multiregion",
    "v2RetrieveIdentity": "/multiregion",
    "v2RetrieveIdentityInternal": "/multiregion",
    "v2RetrieveInboundTransfer": "/multiregion",
    "v2RetrieveInboundTransferMandate": "/multiregion",
    "v2RetrieveInlineTenantMigrationRecord": "/multiregion",
    "v2RetrieveInquiry": "/multiregion",
    "v2RetrieveInsightsByAlertIds": "/multiregion",
    "v2RetrieveInsightsByRequestId": "/multiregion",
    "v2RetrieveIntegHlthAlert": "/multiregion",
    "v2RetrieveIntegrationDataPoint": "/multiregion",
    "v2RetrieveIntent": "/multiregion",
    "v2RetrieveIntentAction": "/multiregion",
    "v2RetrieveJavaLlama": "/multiregion",
    "v2RetrieveJavaLlamaCompartment": "/multiregion",
    "v2RetrieveJournalEntry": "/multiregion",
    "v2RetrieveKYCProjectionByCompartmentGQL": "/multiregion",
    "v2RetrieveLedgerAccount": "/multiregion",
    "v2RetrieveLicenseFee": "/multiregion",
    "v2RetrieveLicenseFeeSubscription": "/multiregion",
    "v2RetrieveLicenseFeeVersion": "/multiregion",
    "v2RetrieveLicensedItem": "/multiregion",
    "v2RetrieveLlama": "/multiregion",
    "v2RetrieveLlamaAccessCondition": "/multiregion",
    "v2RetrieveLlamaAnonymous": "/multiregion",
    "v2RetrieveLlamaCheckout": "/multiregion",
    "v2RetrieveLlamaEvaluationTypes": "/multiregion",
    "v2RetrieveLlamaGraphqlOnly": "/multiregion",
    "v2RetrieveLlamaHabitats": "/multiregion",
    "v2RetrieveLlamaKid": "/multiregion",
    "v2RetrieveLlamaSpecializedCondition": "/multiregion",
    "v2RetrieveLlamaUsingNestedQueryParam": "/multiregion",
    "v2RetrieveLlamaWithNoPermissions": "/multiregion",
    "v2RetrieveLogDestination": "/multiregion",
    "v2RetrieveManualRule": "/multiregion",
    "v2RetrieveMerchantConfigForWorkspace": "/multiregion",
    "v2RetrieveMetadataFromClaimSignature": "/multiregion",
    "v2RetrieveMeteredItem": "/multiregion",
    "v2RetrieveNetworkBusinessProfile": "/multiregion",
    "v2RetrieveNetworkBusinessProfileByUsername": "/multiregion",
    "v2RetrieveNetworkBusinessProfileMe": "/multiregion",
    "v2RetrieveNetworkToken": "/multiregion",
    "v2RetrieveOAuthSessions": "/onlinelz",
    "v2RetrieveOAuthSessionsByUserAndCompartment": "/onlinelz",
    "v2RetrieveOAuthSettings": "/onlinelz",
    "v2RetrieveObjectDefinition": "/multiregion",
    "v2RetrieveObjectDefinitionGroup": "/multiregion",
    "v2RetrieveObjectDefinitionGroupVersion": "/multiregion",
    "v2RetrieveObjectDefinitionVersion": "/multiregion",
    "v2RetrieveObjectInspection": "/multiregion",
    "v2RetrieveObjectRecord": "/multiregion",
    "v2RetrieveOffSessionPayment": "/multiregion",
    "v2RetrieveOneTimeItem": "/multiregion",
    "v2RetrieveOrgSupportConversation": "/multiregion",
    "v2RetrieveOrganizationHealthInsightCounts": "/multiregion",
    "v2RetrieveOutboundDestination": "/multiregion",
    "v2RetrieveOutboundPayment": "/multiregion",
    "v2RetrieveOutboundPaymentQuote": "/multiregion",
    "v2RetrieveOutboundPaymentsConfig": "/multiregion",
    "v2RetrieveOutboundSetupIntent": "/multiregion",
    "v2RetrieveOutboundTransfer": "/multiregion",
    "v2RetrievePackagingConfiguration": "/multiregion",
    "v2RetrievePaymentCredentials": "/multiregion",
    "v2RetrievePaymentProfile": "/multiregion",
    "v2RetrievePaymentProfileInternal": "/multiregion",
    "v2RetrievePaymentReservation": "/multiregion",
    "v2RetrievePaymentRetryEvaluation": "/multiregion",
    "v2RetrievePaymentRetrySignal": "/multiregion",
    "v2RetrievePaymentSession": "/multiregion",
    "v2RetrievePayoutIntent": "/multiregion",
    "v2RetrievePayoutLink": "/multiregion",
    "v2RetrievePayoutLinkInternal": "/multiregion",
    "v2RetrievePayoutMethod": "/multiregion",
    "v2RetrievePayoutMethodsBankAccountSpec": "/multiregion",
    "v2RetrievePerson": "/multiregion",
    "v2RetrievePersonDirectAccount": "/multiregion",
    "v2RetrievePipeline": "/multiregion",
    "v2RetrievePlatformEfsEligibility": "/multiregion",
    "v2RetrievePredicateByInsightType": "/multiregion",
    "v2RetrievePredicateByName": "/multiregion",
    "v2RetrievePricingPlan": "/multiregion",
    "v2RetrievePricingPlanComponent": "/multiregion",
    "v2RetrievePricingPlanSubscription": "/multiregion",
    "v2RetrievePricingPlanSubscriptionComponents": "/multiregion",
    "v2RetrievePricingPlanVersion": "/multiregion",
    "v2RetrievePrimitiveLlama": "/multiregion",
    "v2RetrieveProductCatalogImport": "/multiregion",
    "v2RetrieveProfile": "/multiregion",
    "v2RetrieveProject": "/multiregion",
    "v2RetrieveProjectInternal": "/multiregion",
    "v2RetrieveProviderCharges": "/multiregion",
    "v2RetrieveProviderChargesInternal": "/multiregion",
    "v2RetrieveProviderConnectionRequest": "/multiregion",
    "v2RetrieveRateCard": "/multiregion",
    "v2RetrieveRateCardCustomPricingUnitOverageRate": "/multiregion",
    "v2RetrieveRateCardCustomUnitOverageRate": "/multiregion",
    "v2RetrieveRateCardRate": "/multiregion",
    "v2RetrieveRateCardSubscription": "/multiregion",
    "v2RetrieveRateCardVersion": "/multiregion",
    "v2RetrieveReceivedCheckoutSession": "/multiregion",
    "v2RetrieveReceivedCredit": "/multiregion",
    "v2RetrieveReceivedDebit": "/multiregion",
    "v2RetrieveReceivedDebitMandate": "/multiregion",
    "v2RetrieveRecipientConfigForWorkspace": "/multiregion",
    "v2RetrieveRecipientConfigurationSupportableCapabilities": "/multiregion",
    "v2RetrieveRecipientVerification": "/multiregion",
    "v2RetrieveRecurringCreditGrant": "/multiregion",
    "v2RetrieveRecurringCreditGrantVersion": "/multiregion",
    "v2RetrieveRequestLog": "/multiregion",
    "v2RetrieveResource": "/multiregion",
    "v2RetrieveResourceCopyRecord": "/multiregion",
    "v2RetrieveResourceInternal": "/multiregion",
    "v2RetrieveRevenueTreatment": "/multiregion",
    "v2RetrieveRevenueTreatmentItemMapping": "/multiregion",
    "v2RetrieveRevenueTreatmentItemMappingVersion": "/multiregion",
    "v2RetrieveRevenueTreatmentVersion": "/multiregion",
    "v2RetrieveRewardProgram": "/multiregion",
    "v2RetrieveRewardProgramEnrollment": "/multiregion",
    "v2RetrieveRewardProgramRule": "/multiregion",
    "v2RetrieveRolloutConfigLlama": "/multiregion",
    "v2RetrieveRubyFood": "/multiregion",
    "v2RetrieveRubyLlama": "/multiregion",
    "v2RetrieveRubyLlamaAccessConditionTest": "/multiregion",
    "v2RetrieveRubyLlamaCompartment": "/multiregion",
    "v2RetrieveRubyLlamaRolloutConfigTest": "/multiregion",
    "v2RetrieveRubyPet": "/multiregion",
    "v2RetrieveSamlAuthAssertion": "/onlinelz",
    "v2RetrieveSandboxOrganizationCreation": "/multiregion",
    "v2RetrieveScriptCustomization": "/multiregion",
    "v2RetrieveSecurityEvent": "/multiregion",
    "v2RetrieveServiceAction": "/multiregion",
    "v2RetrieveServiceActionVersion": "/multiregion",
    "v2RetrieveServicePrincipal": "/onlinelz",
    "v2RetrieveSettings": "/multiregion",
    "v2RetrieveSettingsVersion": "/multiregion",
    "v2RetrieveSettlementAllocationIntent": "/multiregion",
    "v2RetrieveSettlementAllocationIntentSplit": "/multiregion",
    "v2RetrieveShareableMetric": "/multiregion",
    "v2RetrieveSignalsAccountActivity": "/multiregion",
    "v2RetrieveSignalsAccountEvaluation": "/multiregion",
    "v2RetrieveSpendRequest": "/multiregion",
    "v2RetrieveSsoDomain": "/onlinelz",
    "v2RetrieveSsoDomainDnsVerificationCode": "/onlinelz",
    "v2RetrieveSsoRoleAssignmentConfiguration": "/onlinelz",
    "v2RetrieveStaxRecord": "/multiregion",
    "v2RetrieveStaxRubyRecord": "/multiregion",
    "v2RetrieveStaxRubyTenantMigrationRecord": "/multiregion",
    "v2RetrieveStorerConfigForWorkspace": "/multiregion",
    "v2RetrieveSuggestedBranding": "/multiregion",
    "v2RetrieveTable": "/multiregion",
    "v2RetrieveTeamManagementBehavior": "/onlinelz",
    "v2RetrieveTeamMember": "/onlinelz",
    "v2RetrieveTenantMigrationRecord": "/multiregion",
    "v2RetrieveTransaction": "/multiregion",
    "v2RetrieveTransactionEntry": "/multiregion",
    "v2RetrieveTrustedWorkloadProvider": "/onlinelz",
    "v2RetrieveUcpCheckoutSession": "/multiregion",
    "v2RetrieveUsBankAccount": "/multiregion",
    "v2RetrieveUserGroup": "/onlinelz",
    "v2RetrieveUserGroupState": "/onlinelz",
    "v2RetrieveUserHealthEventMetadata": "/multiregion",
    "v2RetrieveUserLevelExperiment": "/multiregion",
    "v2RetrieveUserPermissions": "/multiregion",
    "v2RetrieveUserProvisioningMethod": "/onlinelz",
    "v2RetrieveVoiceSession": "/multiregion",
    "v2RetrieveWebSecurityDemo": "/multiregion",
    "v2RetrieveWorkflow": "/multiregion",
    "v2RetrieveWorkflowActionSchemas": "/multiregion",
    "v2RetrieveWorkflowDraft": "/multiregion",
    "v2RetrieveWorkflowRun": "/multiregion",
    "v2RetrieveWorkflowVersion": "/multiregion",
    "v2RetrieveWorkspace": "/multiregion",
    "v2RoutingListAccountInternalResources": "/multiregion",
    "v2RoutingListAccounts": "/multiregion",
    "v2RoutingRetrieveAccount": "/multiregion",
    "v2RoutingRetrieveAccountCommunicationSettings": "/multiregion",
    "v2RoutingRetrieveAccountFeatureConfigs": "/multiregion",
    "v2RoutingRetrieveAccountLinkUrlsInternal": "/multiregion",
    "v2RoutingRetrieveKYCProjectionByCompartmentGQL": "/multiregion",
    "v2RoutingSearchAccountInternalResources": "/multiregion",
    "v2RoutingSearchRecipientsInternal": "/multiregion",
    "v2RoutingSearchRecipientsInternalActionFilterCounts": "/multiregion",
    "v2RoutingSearchRecipientsInternalCountryFilterCounts": "/multiregion",
    "v2SearchDirectoryProfiles": "/multiregion",
    "v2SearchDocs": "/multiregion",
    "v2SearchFlows": "/multiregion",
    "v2SearchIntegrationDataPoints": "/multiregion",
    "v2SearchList": "/multiregion",
    "v2SearchNetworkBusinessProfiles": "/multiregion",
    "v2SearchSecurityEvents": "/multiregion",
    "v2SearchTransactions": "/multiregion",
    "v2SecondaryRoutingOfListAccounts": "/multiregion",
    "v2SecondaryRoutingOfListOrchestratedCommerceAgreements": "/multiregion",
    "v2SecondaryRoutingOfListPersons": "/multiregion",
    "v2SecondaryRoutingOfRetrieveAccount": "/multiregion",
    "v2SecondaryRoutingOfRetrieveAccountLinkUrlsInternal": "/multiregion",
    "v2SecondaryRoutingOfRetrieveAccountToken": "/multiregion",
    "v2SecondaryRoutingOfRetrieveOrchestratedCommerceAgreement": "/multiregion",
    "v2SecondaryRoutingOfRetrievePerson": "/multiregion",
    "v2SecondaryRoutingOfRetrievePersonToken": "/multiregion",
    "v2TestBackingServicePermissionCheck": "/multiregion",
    "v2TestPermissionBypassEndpoint": "/multiregion",
    "v2TestScaPada": "/multiregion",
    "v2ValidateMergeScimConflicts": "/onlinelz",
    "v2ValidateMergeSsoDomains": "/onlinelz"
  },
  "mutation": {
    "v2AbortOffSessionPayment": "/multiregion",
    "v2AcceptCryptoInvestmentTerms": "/multiregion",
    "v2AcceptInvite": "/multiregion",
    "v2AcknowledgeConfirmationOfPayee": "/multiregion",
    "v2AcknowledgeHealthInsight": "/multiregion",
    "v2AcknowledgePaymentMethodCoPForRelatedPayoutLinks": "/multiregion",
    "v2AcknowledgeRecipientVerification": "/multiregion",
    "v2ActivateContract": "/multiregion",
    "v2ActivateObjectDefinition": "/multiregion",
    "v2ActivatePipeline": "/multiregion",
    "v2ActivateRewardProgram": "/multiregion",
    "v2ActivateRewardProgramEnrollment": "/multiregion",
    "v2ActivateRewardProgramRule": "/multiregion",
    "v2ActivateSettings": "/multiregion",
    "v2ActivateWorkflow": "/multiregion",
    "v2AddLlamaKids": "/multiregion",
    "v2AddWorkspacesToAccountGroup": "/multiregion",
    "v2ApproveApprovalRequest": "/multiregion",
    "v2ApproveDeviceAuthorization": "/onlinelz",
    "v2ApproveSpendRequest": "/multiregion",
    "v2ArchiveCryptoWallet": "/multiregion",
    "v2ArchiveFinancialAddress": "/multiregion",
    "v2ArchiveFinancialAddressV2": "/multiregion",
    "v2ArchiveGbBankAccount": "/multiregion",
    "v2ArchiveOutboundDestination": "/multiregion",
    "v2ArchivePayoutMethod": "/multiregion",
    "v2ArchiveUsBankAccount": "/multiregion",
    "v2ArchiveWorkflow": "/multiregion",
    "v2AttachAccountResourceToProject": "/multiregion",
    "v2AttachAccountResourceToProjectInternal": "/multiregion",
    "v2AttachPaymentMethod": "/multiregion",
    "v2BootstrapDefaultAccountMapping": "/multiregion",
    "v2BulkEditRateCardRates": "/multiregion",
    "v2BulkUpdateStaxRubyRecords": "/multiregion",
    "v2CalculateTaxV2": "/multiregion",
    "v2CancelApprovalRequest": "/multiregion",
    "v2CancelBatchJob": "/multiregion",
    "v2CancelCadence": "/multiregion",
    "v2CancelCheckoutSession": "/multiregion",
    "v2CancelClaim": "/multiregion",
    "v2CancelContract": "/multiregion",
    "v2CancelExport": "/multiregion",
    "v2CancelFeatureConfigurationIntent": "/multiregion",
    "v2CancelInboundTransferMandate": "/multiregion",
    "v2CancelIntent": "/multiregion",
    "v2CancelLlamaCheckout": "/multiregion",
    "v2CancelOffSessionPayment": "/multiregion",
    "v2CancelOutboundPayment": "/multiregion",
    "v2CancelOutboundSetupIntent": "/multiregion",
    "v2CancelOutboundTransfer": "/multiregion",
    "v2CancelPaymentRetryEvaluation": "/multiregion",
    "v2CancelPayoutIntent": "/multiregion",
    "v2CancelPayoutLink": "/multiregion",
    "v2CancelPricingPlanSubscription": "/multiregion",
    "v2CancelRateCardSubscription": "/multiregion",
    "v2CancelReceivedDebitMandate": "/multiregion",
    "v2CancelSettlementAllocationIntent": "/multiregion",
    "v2CancelSettlementAllocationIntentSplit": "/multiregion",
    "v2CancelUcpCheckoutSession": "/multiregion",
    "v2CancelUserLevelExperiment": "/multiregion",
    "v2CancelUserLevelExperimentV2": "/multiregion",
    "v2CancelWorkflowRun": "/multiregion",
    "v2CaptureOffSessionPayment": "/multiregion",
    "v2CapturePaymentReservation": "/multiregion",
    "v2ClaimSandbox": "/multiregion",
    "v2ClassifySchemaBumpForApi": "/multiregion",
    "v2ClearHealthInsightSuppression": "/multiregion",
    "v2CloneDraftFromExistingWorkflowVersion": "/multiregion",
    "v2CloseFinancialAccount": "/multiregion",
    "v2CloseTestmodeOrganization": "/multiregion",
    "v2CloseTestmodeWorkspace": "/multiregion",
    "v2CollectKyc": "/multiregion",
    "v2CommitIntent": "/multiregion",
    "v2CompleteCheckoutSession": "/multiregion",
    "v2CompleteUcpCheckoutSession": "/multiregion",
    "v2ConfigureOAuthSettings": "/onlinelz",
    "v2ConfirmAccountRequest": "/multiregion",
    "v2ConfirmAccountRequestOauthCallback": "/multiregion",
    "v2ConfirmBill": "/multiregion",
    "v2ConfirmLlamaCheckout": "/multiregion",
    "v2ConfirmMicrodeposits": "/multiregion",
    "v2ConfirmOzoneAuthorization": "/multiregion",
    "v2ConfirmPaymentMethodRequest": "/multiregion",
    "v2ConfirmPayoutIntent": "/multiregion",
    "v2CreateAccountEvaluation": "/multiregion",
    "v2CreateAccountGroup": "/multiregion",
    "v2CreateAccountRequestInternal": "/multiregion",
    "v2CreateAccountSession": "/multiregion",
    "v2CreateAcfTest": "/multiregion",
    "v2CreateApiKey": "/multiregion",
    "v2CreateAuthor": "/multiregion",
    "v2CreateBalanceExchange": "/multiregion",
    "v2CreateBatchJob": "/multiregion",
    "v2CreateBill": "/multiregion",
    "v2CreateBillSetting": "/multiregion",
    "v2CreateBook": "/multiregion",
    "v2CreateCadence": "/multiregion",
    "v2CreateCalculation": "/multiregion",
    "v2CreateCatalogItem": "/multiregion",
    "v2CreateCheckoutIntegration": "/multiregion",
    "v2CreateCheckoutPlan": "/multiregion",
    "v2CreateCheckoutSession": "/multiregion",
    "v2CreateClaim": "/multiregion",
    "v2CreateClaimableSandbox": "/multiregion",
    "v2CreateCollectionSetting": "/multiregion",
    "v2CreateCompartmentKey": "/multiregion",
    "v2CreateConnectionSession": "/multiregion",
    "v2CreateContract": "/multiregion",
    "v2CreateContractPricingSegmentPreview": "/multiregion",
    "v2CreateCorgiMission": "/multiregion",
    "v2CreateCryptoInvestmentDeposit": "/multiregion",
    "v2CreateCryptoInvestmentWithdrawal": "/multiregion",
    "v2CreateCryptoWallet": "/multiregion",
    "v2CreateCurrencyConversion": "/multiregion",
    "v2CreateCustomPricingUnit": "/multiregion",
    "v2CreateCustomRole": "/multiregion",
    "v2CreateDatabase": "/multiregion",
    "v2CreateDatabaseUser": "/multiregion",
    "v2CreateDebitDispute": "/multiregion",
    "v2CreateDeepLink": "/multiregion",
    "v2CreateDeepLinkInternal": "/multiregion",
    "v2CreateDraftSession": "/multiregion",
    "v2CreateEventDestination": "/multiregion",
    "v2CreateExpense": "/multiregion",
    "v2CreateExport": "/multiregion",
    "v2CreateFeatureConfigurationIntent": "/multiregion",
    "v2CreateFinancialAccountV2": "/multiregion",
    "v2CreateFinancialAddress": "/multiregion",
    "v2CreateFinancialAddressV2": "/multiregion",
    "v2CreateFineGrainedSand": "/multiregion",
    "v2CreateFundingSession": "/multiregion",
    "v2CreateFundingSessionFinancialAddress": "/multiregion",
    "v2CreateFxQuote": "/multiregion",
    "v2CreateFxQuoteForOriginatedMoneyTransfer": "/multiregion",
    "v2CreateFxQuoteForOutboundPaymentQuotes": "/multiregion",
    "v2CreateGbBankAccount": "/multiregion",
    "v2CreateInboundTransfer": "/multiregion",
    "v2CreateInboundTransferMandate": "/multiregion",
    "v2CreateInlineTenantMigrationRecord": "/multiregion",
    "v2CreateIntent": "/multiregion",
    "v2CreateLedgerAccount": "/multiregion",
    "v2CreateLicenseFee": "/multiregion",
    "v2CreateLicensedItem": "/multiregion",
    "v2CreateLlama": "/multiregion",
    "v2CreateLlamaCheckout": "/multiregion",
    "v2CreateLogDestination": "/multiregion",
    "v2CreateManualRule": "/multiregion",
    "v2CreateMeteredItem": "/multiregion",
    "v2CreateMetronomeAccount": "/multiregion",
    "v2CreateNetworkToken": "/multiregion",
    "v2CreateNetworkTokenFromCredential": "/multiregion",
    "v2CreateObjectDefinition": "/multiregion",
    "v2CreateObjectRecord": "/multiregion",
    "v2CreateOffSessionPayment": "/multiregion",
    "v2CreateOneTimeItem": "/multiregion",
    "v2CreateOrUpdateCorgi": "/multiregion",
    "v2CreateOrderEvent": "/multiregion",
    "v2CreateOrganization": "/multiregion",
    "v2CreateOutboundDestination": "/multiregion",
    "v2CreateOutboundDestinationFromFinancialConnectionsResult": "/multiregion",
    "v2CreateOutboundPayment": "/multiregion",
    "v2CreateOutboundPaymentQuote": "/multiregion",
    "v2CreateOutboundSetupIntent": "/multiregion",
    "v2CreateOutboundSetupIntentFromFinancialConnections": "/multiregion",
    "v2CreateOutboundTransfer": "/multiregion",
    "v2CreatePackagingConfiguration": "/multiregion",
    "v2CreatePaymentMethodRequest": "/multiregion",
    "v2CreatePaymentMethodRequestInternal": "/multiregion",
    "v2CreatePaymentRetryEvaluation": "/multiregion",
    "v2CreatePaymentSession": "/multiregion",
    "v2CreatePayoutIntent": "/multiregion",
    "v2CreatePayoutLink": "/multiregion",
    "v2CreatePayoutLinkEmail": "/multiregion",
    "v2CreatePayoutLinkUrlInternal": "/multiregion",
    "v2CreatePerson": "/multiregion",
    "v2CreatePersonDirectAccount": "/multiregion",
    "v2CreatePipeline": "/multiregion",
    "v2CreatePointInTime": "/multiregion",
    "v2CreatePricingPlan": "/multiregion",
    "v2CreatePricingPlanComponent": "/multiregion",
    "v2CreatePrimitiveLlama": "/multiregion",
    "v2CreateProductCatalogImport": "/multiregion",
    "v2CreateProfile": "/multiregion",
    "v2CreateProgram": "/multiregion",
    "v2CreateProject": "/multiregion",
    "v2CreateProjectEphemeralKey": "/multiregion",
    "v2CreateProjectInternal": "/multiregion",
    "v2CreateProviderConnectionRequest": "/multiregion",
    "v2CreatePublicWorkflowDraft": "/multiregion",
    "v2CreateRateCard": "/multiregion",
    "v2CreateRateCardCustomPricingUnitOverageRate": "/multiregion",
    "v2CreateRateCardCustomUnitOverageRate": "/multiregion",
    "v2CreateRateCardRate": "/multiregion",
    "v2CreateRateCardSubscription": "/multiregion",
    "v2CreateReceivedDebitMandate": "/multiregion",
    "v2CreateRecipientVerification": "/multiregion",
    "v2CreateRecurringCreditGrant": "/multiregion",
    "v2CreateResource": "/multiregion",
    "v2CreateResourceInternal": "/multiregion",
    "v2CreateRevenueTreatment": "/multiregion",
    "v2CreateRevenueTreatmentItemMapping": "/multiregion",
    "v2CreateRewardProgram": "/multiregion",
    "v2CreateRewardProgramEnrollment": "/multiregion",
    "v2CreateRewardProgramRule": "/multiregion",
    "v2CreateRubyFood": "/multiregion",
    "v2CreateRubyLlama": "/multiregion",
    "v2CreateRubyPet": "/multiregion",
    "v2CreateSandbox": "/multiregion",
    "v2CreateSandboxOrganization": "/multiregion",
    "v2CreateSandboxUnderSandboxOrganization": "/multiregion",
    "v2CreateScriptCustomization": "/multiregion",
    "v2CreateServiceAction": "/multiregion",
    "v2CreateServicePrincipal": "/onlinelz",
    "v2CreateSettlementAllocationIntent": "/multiregion",
    "v2CreateSettlementAllocationIntentSplit": "/multiregion",
    "v2CreateSignalsAccountActivity": "/multiregion",
    "v2CreateSignalsAccountEvaluation": "/multiregion",
    "v2CreateSpendRequest": "/multiregion",
    "v2CreateSsoDomain": "/onlinelz",
    "v2CreateSsoDomainFromExisting": "/onlinelz",
    "v2CreateSsoRoleAssignmentConfiguration": "/onlinelz",
    "v2CreateStaxCrossModeSharedConfig": "/multiregion",
    "v2CreateStaxRecord": "/multiregion",
    "v2CreateStaxRubyRecord": "/multiregion",
    "v2CreateStaxRubyTenantMigrationRecord": "/multiregion",
    "v2CreateTenantMigrationRecord": "/multiregion",
    "v2CreateTenantMigrationRecordInBatch": "/multiregion",
    "v2CreateTestAdjustment": "/multiregion",
    "v2CreateTrustedWorkloadProvider": "/onlinelz",
    "v2CreateUcpCheckoutSession": "/multiregion",
    "v2CreateUsBankAccount": "/multiregion",
    "v2CreateUsBankAccountFromFinancialConnectionsAccount": "/multiregion",
    "v2CreateUsageAdjustmentV2Synchronous": "/multiregion",
    "v2CreateUsageV2Synchronous": "/multiregion",
    "v2CreateUserHealthEventMetadata": "/multiregion",
    "v2CreateUserLevelExperiment": "/multiregion",
    "v2CreateUserLevelExperimentV2": "/multiregion",
    "v2CreateVoiceSession": "/multiregion",
    "v2CreateWorkflow": "/multiregion",
    "v2CreateWorkflowDraft": "/multiregion",
    "v2CreateWorkspace": "/multiregion",
    "v2CreditFinancialAddress": "/multiregion",
    "v2DashboardActivateWorkflow": "/multiregion",
    "v2DashboardCreateWorkflow": "/multiregion",
    "v2DashboardDeactivateWorkflow": "/multiregion",
    "v2DashboardGenerateVersionSummary": "/multiregion",
    "v2DashboardUpdateWorkflow": "/multiregion",
    "v2DashboardUpdateWorkflowVersion": "/multiregion",
    "v2DeactivateAccount": "/multiregion",
    "v2DeactivateAlertForMhnsResolution": "/multiregion",
    "v2DeactivateManualRule": "/multiregion",
    "v2DeactivateObjectDefinition": "/multiregion",
    "v2DeactivateRewardProgram": "/multiregion",
    "v2DeactivateRewardProgramEnrollment": "/multiregion",
    "v2DeactivateRewardProgramRule": "/multiregion",
    "v2DeactivateScriptCustomization": "/multiregion",
    "v2DeactivateWorkflow": "/multiregion",
    "v2DebitFinancialAddress": "/multiregion",
    "v2DeleteAccountGroup": "/multiregion",
    "v2DeleteAllObjectRecord": "/multiregion",
    "v2DeleteAuthor": "/multiregion",
    "v2DeleteBill": "/multiregion",
    "v2DeleteBookAsync": "/multiregion",
    "v2DeleteBookMultipleCompartments": "/multiregion",
    "v2DeleteCheckoutPlan": "/multiregion",
    "v2DeleteCompartmentKey": "/multiregion",
    "v2DeleteContract": "/multiregion",
    "v2DeleteCorgi": "/multiregion",
    "v2DeleteCustomRole": "/multiregion",
    "v2DeleteDatabase": "/multiregion",
    "v2DeleteDatabaseUser": "/multiregion",
    "v2DeleteDraftSessionMutation": "/multiregion",
    "v2DeleteEventDestination": "/multiregion",
    "v2DeleteIamAuthToken": "/multiregion",
    "v2DeleteInlineTenantMigrationRecord": "/multiregion",
    "v2DeleteKeyRestrictionTemplate": "/multiregion",
    "v2DeleteLogDestination": "/multiregion",
    "v2DeleteObjectDefinition": "/multiregion",
    "v2DeleteObjectRecord": "/multiregion",
    "v2DeletePerson": "/multiregion",
    "v2DeletePersonDirectAccount": "/multiregion",
    "v2DeletePipeline": "/multiregion",
    "v2DeletePointInTime": "/multiregion",
    "v2DeletePricingPlanComponent": "/multiregion",
    "v2DeleteProjectVariable": "/multiregion",
    "v2DeleteProjectVariableInternal": "/multiregion",
    "v2DeletePublicWorkflowDraft": "/multiregion",
    "v2DeleteRateCardCustomPricingUnitOverageRate": "/multiregion",
    "v2DeleteRateCardCustomUnitOverageRate": "/multiregion",
    "v2DeleteRateCardRate": "/multiregion",
    "v2DeleteRubyLlama": "/multiregion",
    "v2DeleteScriptCustomization": "/multiregion",
    "v2DeleteServicePrincipal": "/onlinelz",
    "v2DeleteSignalsAccountActivity": "/multiregion",
    "v2DeleteSsoDomain": "/onlinelz",
    "v2DeleteStaxCrossModeSharedConfig": "/multiregion",
    "v2DeleteStaxRubyRecord": "/multiregion",
    "v2DeleteStaxRubyTenantMigrationRecord": "/multiregion",
    "v2DeleteTenantMigrationRecord": "/multiregion",
    "v2DeleteTenantMigrationRecordWithDeleteOps": "/multiregion",
    "v2DeleteWorkflowDraft": "/multiregion",
    "v2DetachAccountResourceFromProject": "/multiregion",
    "v2DetachAccountResourceFromProjectInternal": "/multiregion",
    "v2DisableEventDestination": "/multiregion",
    "v2DisablePayoutMethod": "/multiregion",
    "v2DismissResourceSharingEligibilityCheck": "/multiregion",
    "v2EditRateCardRates": "/multiregion",
    "v2EnableEventDestination": "/multiregion",
    "v2ExchangeOAuthToken": "/multiregion",
    "v2ExecuteApprovalRequest": "/multiregion",
    "v2ExecuteFeatureConfigurationIntentAction": "/multiregion",
    "v2ExecuteFeatureConfigurationIntentWorkflow": "/multiregion",
    "v2ExpireApiKey": "/multiregion",
    "v2ExportFinancialAccountWalletCredentials": "/multiregion",
    "v2ExtractBillDetails": "/multiregion",
    "v2Fabric": "/multiregion",
    "v2FinalizeQuestionnaire": "/multiregion",
    "v2FxQuotePayoutIntent": "/multiregion",
    "v2GenerateCheckoutIntegrationIdentifier": "/multiregion",
    "v2GenerateMicrodepositsFinancialAddress": "/multiregion",
    "v2GenerateNetworkTokenCryptogram": "/multiregion",
    "v2GetOAuthUrl": "/multiregion",
    "v2GetRecipientInformation": "/multiregion",
    "v2GetStaxCrossModeSharedConfig": "/multiregion",
    "v2GroomLlama": "/multiregion",
    "v2IngestLlamaEvent": "/multiregion",
    "v2InitiateConfirmationOfPayee": "/multiregion",
    "v2InspectTenantMigrationRecords": "/multiregion",
    "v2InstallAppOnLivemode": "/multiregion",
    "v2InternalPokeWorkflow": "/multiregion",
    "v2InviteUsersToCompartments": "/onlinelz",
    "v2InvokeObjectRecordMethod": "/multiregion",
    "v2InvokeWorkflow": "/multiregion",
    "v2IssueMetronomeUserToken": "/multiregion",
    "v2LinkResource": "/multiregion",
    "v2LinkResourceInternal": "/multiregion",
    "v2MarkDraftBill": "/multiregion",
    "v2ModifyRates": "/multiregion",
    "v2MutateManyCorgis": "/multiregion",
    "v2MutateStaxRubyRecordWithPessimisticLock": "/multiregion",
    "v2MutateTenantMigrationRecordsWithUpdateOps": "/multiregion",
    "v2OnboardFinancialAccount": "/multiregion",
    "v2PauseOffSessionPayment": "/multiregion",
    "v2PausePipeline": "/multiregion",
    "v2PayBill": "/multiregion",
    "v2PaymentIntentConfirm": "/multiregion",
    "v2PingEventDestination": "/multiregion",
    "v2PostUserState": "/multiregion",
    "v2PrepareProjectsAccess": "/multiregion",
    "v2PrepareProjectsAccessInternal": "/multiregion",
    "v2PublishDraftSession": "/multiregion",
    "v2PurchaseLlama": "/multiregion",
    "v2PurchaseLlamaV2": "/multiregion",
    "v2PurchasePreviewLlama": "/multiregion",
    "v2PushAddResource": "/multiregion",
    "v2PushRemoveResource": "/multiregion",
    "v2PushUpdateResource": "/multiregion",
    "v2ReactivateScriptCustomization": "/multiregion",
    "v2RecordGearsetDeployment": "/multiregion",
    "v2RefreshRecipientVerificationPayoutIntent": "/multiregion",
    "v2RejectApprovalRequest": "/multiregion",
    "v2RejectOzoneAuthorization": "/multiregion",
    "v2ReleasePaymentReservation": "/multiregion",
    "v2ReleaseReservationIntent": "/multiregion",
    "v2RemoveDiscountsPricingPlanSubscription": "/multiregion",
    "v2RemoveResource": "/multiregion",
    "v2RemoveResourceInternal": "/multiregion",
    "v2RemoveWorkspaceParent": "/multiregion",
    "v2RemoveWorkspacesFromAccountGroup": "/multiregion",
    "v2RenewOnboardingLink": "/multiregion",
    "v2RequestAccountRequestInformation": "/multiregion",
    "v2ResendEventToEventDestination": "/multiregion",
    "v2ReserveIntent": "/multiregion",
    "v2ResolveAddress": "/multiregion",
    "v2ResumeOffSessionPayment": "/multiregion",
    "v2RetrieveAuthorForMerchant": "/multiregion",
    "v2RetrieveClaimMetadata": "/multiregion",
    "v2RevokeAllAccess": "/onlinelz",
    "v2RevokeAllClientOAuthSessions": "/onlinelz",
    "v2RevokeClientOAuthSession": "/onlinelz",
    "v2RevokeClientOAuthSessionByCompartment": "/onlinelz",
    "v2RevokeInvite": "/multiregion",
    "v2RevokeUserInvites": "/onlinelz",
    "v2RollEventDestinationWebhookSigningKey": "/multiregion",
    "v2RotateApiKey": "/multiregion",
    "v2RotateCompartmentKey": "/multiregion",
    "v2RotateResourceCredentials": "/multiregion",
    "v2RotateResourceCredentialsInternal": "/multiregion",
    "v2RoutingCloseAccount": "/multiregion",
    "v2RoutingCompleteAccountLink": "/multiregion",
    "v2RoutingConsumeAccountLink": "/multiregion",
    "v2RoutingCreateAccount": "/multiregion",
    "v2RoutingCreateAccountLink": "/multiregion",
    "v2RoutingCreateAccountLinkInternal": "/multiregion",
    "v2RoutingCreateRecipientOnboardingEmail": "/multiregion",
    "v2RoutingCreateRecipientUpdateEmail": "/multiregion",
    "v2RoutingUpdateAccount": "/multiregion",
    "v2RoutingUpdateAccountCommunicationSettings": "/multiregion",
    "v2RoutingUpdateAccountFeatureConfigs": "/multiregion",
    "v2RunResourceSharingEligibilityCheck": "/multiregion",
    "v2SearchBills": "/multiregion",
    "v2SearchObjectRecord": "/multiregion",
    "v2SecondaryRoutingOfCloseAccount": "/multiregion",
    "v2SecondaryRoutingOfCompleteAccountLink": "/multiregion",
    "v2SecondaryRoutingOfConfirmAgreement": "/multiregion",
    "v2SecondaryRoutingOfConsumeAccountLink": "/multiregion",
    "v2SecondaryRoutingOfCreateAccount": "/multiregion",
    "v2SecondaryRoutingOfCreateAccountLink": "/multiregion",
    "v2SecondaryRoutingOfCreateAccountLinkInternal": "/multiregion",
    "v2SecondaryRoutingOfCreateAccountToken": "/multiregion",
    "v2SecondaryRoutingOfCreateOrchestratedCommerceAgreement": "/multiregion",
    "v2SecondaryRoutingOfCreatePerson": "/multiregion",
    "v2SecondaryRoutingOfCreatePersonToken": "/multiregion",
    "v2SecondaryRoutingOfCreateRecipientOnboardingEmail": "/multiregion",
    "v2SecondaryRoutingOfCreateRecipientUpdateEmail": "/multiregion",
    "v2SecondaryRoutingOfTerminateAgreement": "/multiregion",
    "v2SecondaryRoutingOfUpdateAccount": "/multiregion",
    "v2SecondaryRoutingOfUpdatePerson": "/multiregion",
    "v2SendInvite": "/multiregion",
    "v2SendMicrodeposits": "/multiregion",
    "v2SendPolicyFeedback": "/multiregion",
    "v2SendRecipientPayout": "/multiregion",
    "v2SetRoleAssignmentsForUserGroup": "/onlinelz",
    "v2SetUserRoleAssignmentsInCompartments": "/onlinelz",
    "v2SetupIntentConfirm": "/multiregion",
    "v2ShaveRubyLlama": "/multiregion",
    "v2SimulateFinancialAddressCredit": "/multiregion",
    "v2SimulatePreviousEarningPeriodTestHelper": "/multiregion",
    "v2SubmitAccountRequestInformationInternal": "/multiregion",
    "v2SubmitApprovalRequest": "/multiregion",
    "v2SubmitInquiry": "/multiregion",
    "v2SubmitProviderConnectionRequestInformation": "/multiregion",
    "v2SubmitResourceInformation": "/multiregion",
    "v2SubmitResourceInformationInternal": "/multiregion",
    "v2SubmitSettlementAllocationIntent": "/multiregion",
    "v2TeachLlamaRuby": "/multiregion",
    "v2TestAuthenticatedWebSecurity": "/multiregion",
    "v2TestConnection": "/multiregion",
    "v2TestEmptyResponse": "/multiregion",
    "v2TestHelperCreateEarnedCredit": "/multiregion",
    "v2TestHelperCreateRecipientVerification": "/multiregion",
    "v2TestHelperFailInboundTransfer": "/multiregion",
    "v2TestHelperResolveHealthAlert": "/multiregion",
    "v2TestHelperReturnInboundTransfer": "/multiregion",
    "v2TestHelperSucceedInboundTransfer": "/multiregion",
    "v2TestHelperTriggerHealthAlert": "/multiregion",
    "v2ToggleFunctionality": "/multiregion",
    "v2UcpTokenize": "/multiregion",
    "v2UnarchiveGbBankAccount": "/multiregion",
    "v2UnarchivePayoutMethod": "/multiregion",
    "v2UnarchiveUsBankAccount": "/multiregion",
    "v2UnlinkProviderConnection": "/multiregion",
    "v2UnlinkProviderConnectionInternal": "/multiregion",
    "v2UnlinkResource": "/multiregion",
    "v2UnlinkResourceInternal": "/multiregion",
    "v2UpdateAccountGroup": "/multiregion",
    "v2UpdateApiKey": "/multiregion",
    "v2UpdateApprovalRequest": "/multiregion",
    "v2UpdateBill": "/multiregion",
    "v2UpdateBillSetting": "/multiregion",
    "v2UpdateCadence": "/multiregion",
    "v2UpdateCatalogItem": "/multiregion",
    "v2UpdateCheckoutIntegration": "/multiregion",
    "v2UpdateCheckoutPlan": "/multiregion",
    "v2UpdateCheckoutSession": "/multiregion",
    "v2UpdateCollectionSetting": "/multiregion",
    "v2UpdateCompartmentKey": "/multiregion",
    "v2UpdateContract": "/multiregion",
    "v2UpdateCustomPricingUnit": "/multiregion",
    "v2UpdateCustomRole": "/multiregion",
    "v2UpdateCustomerConsentRequest": "/onlinelz",
    "v2UpdateDefaultAccountMapping": "/multiregion",
    "v2UpdateDirectAccount": "/multiregion",
    "v2UpdateEventDestination": "/multiregion",
    "v2UpdateExpense": "/multiregion",
    "v2UpdateFeatures": "/multiregion",
    "v2UpdateFinancialAccount": "/multiregion",
    "v2UpdateHealthAlertUserMetadata": "/multiregion",
    "v2UpdateHealthInsight": "/multiregion",
    "v2UpdateHealthInsightUserMetadata": "/multiregion",
    "v2UpdateKeyRestrictionTemplateForKey": "/multiregion",
    "v2UpdateLedgerAccount": "/multiregion",
    "v2UpdateLicenseFee": "/multiregion",
    "v2UpdateLicensedItem": "/multiregion",
    "v2UpdateLlama": "/multiregion",
    "v2UpdateLlamaCheckout": "/multiregion",
    "v2UpdateLogDestination": "/multiregion",
    "v2UpdateManualRule": "/multiregion",
    "v2UpdateMerchantConfigForWorkspace": "/multiregion",
    "v2UpdateMeteredItem": "/multiregion",
    "v2UpdateObjectDefinition": "/multiregion",
    "v2UpdateObjectRecord": "/multiregion",
    "v2UpdateOneTimeItem": "/multiregion",
    "v2UpdateOrganizationAttributes": "/multiregion",
    "v2UpdateOrganizationSandboxAccessLevel": "/multiregion",
    "v2UpdateOutboundSetupIntent": "/multiregion",
    "v2UpdatePackagingConfiguration": "/multiregion",
    "v2UpdatePaymentMethodLimit": "/multiregion",
    "v2UpdatePaymentMethodLimitInternal": "/multiregion",
    "v2UpdatePaymentRetryEvaluation": "/multiregion",
    "v2UpdatePayoutIntent": "/multiregion",
    "v2UpdatePersonDirectAccount": "/multiregion",
    "v2UpdatePipeline": "/multiregion",
    "v2UpdatePricingPlan": "/multiregion",
    "v2UpdatePricingPlanComponent": "/multiregion",
    "v2UpdatePricingPlanSubscription": "/multiregion",
    "v2UpdateProfile": "/multiregion",
    "v2UpdateProgram": "/multiregion",
    "v2UpdateProject": "/multiregion",
    "v2UpdateProjectInternal": "/multiregion",
    "v2UpdatePublicWorkflowDraft": "/multiregion",
    "v2UpdateQuestionnaire": "/multiregion",
    "v2UpdateRateCard": "/multiregion",
    "v2UpdateRateCardSubscription": "/multiregion",
    "v2UpdateRates": "/multiregion",
    "v2UpdateReceivedDebitMandate": "/multiregion",
    "v2UpdateRecurringCreditGrant": "/multiregion",
    "v2UpdateResource": "/multiregion",
    "v2UpdateResourceInternal": "/multiregion",
    "v2UpdateRevenueTreatment": "/multiregion",
    "v2UpdateRevenueTreatmentItemMapping": "/multiregion",
    "v2UpdateRewardProgram": "/multiregion",
    "v2UpdateRewardProgramRule": "/multiregion",
    "v2UpdateRubyLlama": "/multiregion",
    "v2UpdateSandboxAccessLevel": "/multiregion",
    "v2UpdateScriptCustomization": "/multiregion",
    "v2UpdateServiceAction": "/multiregion",
    "v2UpdateServicePrincipal": "/onlinelz",
    "v2UpdateSettings": "/multiregion",
    "v2UpdateSettlementAllocationIntent": "/multiregion",
    "v2UpdateSsoDomain": "/onlinelz",
    "v2UpdateSsoRoleAssignmentConfiguration": "/onlinelz",
    "v2UpdateStaxCrossModeSharedConfig": "/multiregion",
    "v2UpdateStaxRubyRecord": "/multiregion",
    "v2UpdateStaxRubyTenantMigrationRecord": "/multiregion",
    "v2UpdateTaxIntegrationConfiguration": "/multiregion",
    "v2UpdateTenantMigrationRecord": "/multiregion",
    "v2UpdateTransaction": "/multiregion",
    "v2UpdateUcpCheckoutSession": "/multiregion",
    "v2UpdateUsBankAccount": "/multiregion",
    "v2UpdateUserProvisioningMethod": "/onlinelz",
    "v2UpdateWorkflow": "/multiregion",
    "v2UpdateWorkflowDraft": "/multiregion",
    "v2UpdateWorkspaceParent": "/multiregion",
    "v2UpsertAgreement": "/multiregion",
    "v2UpsertBillingTransaction": "/multiregion",
    "v2UpsertDelivery": "/multiregion",
    "v2UpsertHealthAlertCategoryConfig": "/multiregion",
    "v2UpsertKeyRestrictionTemplate": "/multiregion",
    "v2UpsertMfa": "/onlinelz",
    "v2UpsertProjectVariable": "/multiregion",
    "v2UpsertProjectVariableInternal": "/multiregion",
    "v2ValidateFxQuote": "/multiregion",
    "v2ValidateFxQuoteForOriginatedMoneyTransfer": "/multiregion",
    "v2ValidateTrustedWorkloadProviderConfiguration": "/onlinelz",
    "v2VerifyAtomicBatchWrite": "/multiregion",
    "v2VerifyAtomicBatchWriteBulkUpdate": "/multiregion",
    "v2VerifyDeviceUserCode": "/onlinelz",
    "v2VerifyOptimisticLocking": "/multiregion",
    "v2VerifyReadPaths": "/multiregion",
    "v2VerifySnapshotReads": "/multiregion",
    "v2VerifySsoDomain": "/onlinelz",
    "v2VerifyStaxRubyAtomicBatchWrite": "/multiregion",
    "v2VerifyStaxRubyMutatorSession": "/multiregion",
    "v2VerifyStaxRubyOptimisticLocking": "/multiregion",
    "v2VerifyStaxRubyPessimisticLocking": "/multiregion",
    "v2VerifyStaxRubyReadPaths": "/multiregion",
    "v2VerifyStaxRubySnapshotReads": "/multiregion",
    "v2VoidAgreement": "/multiregion",
    "v2VoidBill": "/multiregion",
    "v2VoidBillingTransaction": "/multiregion",
    "v2VoidDelivery": "/multiregion"
  },
  "subscription": {}
}